<p-toast [baseZIndex]="5000"></p-toast>
<!-- New build deployed: offer a reload (see AppUpdateService) -->
@if (updateAvailable()) {
  <div class="app-update-banner" role="status" aria-live="polite">
    <i class="pi pi-sparkles" aria-hidden="true"></i>
    <span>A new version of Pure BI is available with the latest fixes.</span>
    <button type="button" class="app-update-reload" (click)="reloadForUpdate()">
      Reload
    </button>
  </div>
}
<!-- Global Upload Status Component -->
<app-global-upload-status></app-global-upload-status>
<!-- <app-main-page></app-main-page> -->
<router-outlet></router-outlet>
<!-- GDPR / ePrivacy cookie-consent banner (shown until a choice is recorded) -->
<app-cookie-consent></app-cookie-consent>
<!-- Shared AI feedback reason dialog (EU AI Act / ISO 42001) -->
<app-ai-feedback-dialog></app-ai-feedback-dialog>

